export type EmptyString = '';

export interface Pagination<T> {
  totalRecords: number;
  records: Array<T>;
  page: number;
  recordsPerPage: number;
  metaData?: Record<string, string | number> | null;
}

export interface SelectItem {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface AdditionalFilters {
  sortField: string;
  ascendingOrder: boolean;
  page?: string | number;
}
export interface AppliedFilters {
  [key: string]: string | boolean | number | undefined;
}
export type CombinedFilters = AdditionalFilters & AppliedFilters;

export const DEFAULT_ADDITIONAL_FILTERS = {
  sortField: 'createDate',
  ascendingOrder: false,
};

export type { UseCase as UsecaseType } from '@/apis/core/types';

export interface Cnp {
  uid: string;
  displayName: string;
}

export interface Mno {
  networkId: number;
  displayName: string;
  osrBitmaskIndex: number;
}

export enum AttachmentFolder {
  SampleMultimedia = 'MMS_SAMPLE_MEDIA',
  SupportingDocument = 'SUPPORTING_DOCUMENT',
  VettingAppeal = 'VET_APPEAL',
  BrandAssetLogo = 'BRAND_ASSET_LOGO',
  BrandAssetBanner = 'BRAND_ASSET_BANNER',
}
